export default function wooNotices() {
  let noticesWrapper = document.querySelector('.woocommerce-notices-wrapper');
  if (noticesWrapper) {
    for (let child of noticesWrapper.children) {
      console.log(child);
      addNoticeClose(child);
    }
    // let observer = new MutationObserver((mutationsList, observer) => {
    //   for (let child of noticesWrapper.children) {
    //     addNoticeClose(child);
    //   }
    // });
    // observer.observe(noticesWrapper, {
    //   childList: true,
    // });
  }

  // let elementToObserve = document.querySelector('.woocommerce-checkout');
  // if (elementToObserve) {
  //   let observer = new MutationObserver((mutationsList, observer) => {        
  //     let noticeGroup = document.querySelector('.woocommerce-NoticeGroup-checkout');
  //     for (let child of noticeGroup.children) {
  //       addNoticeClose(child);
  //     }
  //   });
  //   observer.observe(elementToObserve, {
  //     childList: true,
  //   });
  // }

  function addNoticeClose(el) {
    // check if close wasn't already added
    if (el.querySelector('.woocommerce-notice-close')) return;
    
    let close = document.createElement('button');
    close.type = 'button';
    close.classList.add('woocommerce-notice-close');
    el.appendChild(close);

    close.addEventListener('click', function() {
      animateClose(this.parentNode);
    });
  }

  function animateClose(el) {
    el.style['display'] = 'none';
    // el.style.animation = `fade-out 0.5s ease forwards`;
    // el.addEventListener('animationend', function() {
    //   el.remove();
    // });
  }
}